const partyText = t => ({
  document: t('SALES_PARTIES.DOCUMENTS.DOCUMENT'),
  expiresOn: t('SALES_PARTIES.DOCUMENTS.EXPIRES_ON'),
  issuedOn: t('SALES_PARTIES.DOCUMENTS.ISSUED_ON'),
  noExpiresOn: t('SALES_PARTIES.COMMON.NO_DATA'),
  noIssuedOn: t('SALES_PARTIES.COMMON.NO_DATA'),
  saveTypes: t('SALES_PARTIES.DOCUMENTS.SAVE_TYPES'),
  types: t('SALES_PARTIES.DOCUMENTS.TYPES'),
  typesSelected: t('SALES_PARTIES.DOCUMENTS.TYPES_SELECTED'),
  typesEmpty: t('SALES_PARTIES.CATALOG.DOCUMENT_TYPES_EMPTY'),
  typesHelper: t('SALES_PARTIES.DOCUMENTS.TYPES_HELPER'),
  validityDays: t('SALES_PARTIES.DOCUMENTS.VALIDITY_DAYS'),
});

const propertyText = t => ({
  document: t('SALES_PROPERTY.DOCUMENTS.DOCUMENT'),
  expiresOn: t('SALES_PROPERTY.DOCUMENTS.EXPIRES_ON'),
  issuedOn: t('SALES_PROPERTY.DOCUMENTS.ISSUED_ON'),
  noExpiresOn: t('SALES_PROPERTY.DOCUMENTS.NO_EXPIRES_ON'),
  noIssuedOn: t('SALES_PROPERTY.DOCUMENTS.NO_ISSUED_ON'),
  saveTypes: t('SALES_PROPERTY.DOCUMENTS.SAVE_TYPES'),
  types: t('SALES_PROPERTY.DOCUMENTS.TYPES'),
  typesSelected: t('SALES_PROPERTY.DOCUMENTS.TYPES_SELECTED'),
  typesEmpty: t('SALES_PROPERTY.DOCUMENTS.TYPES_EMPTY'),
  typesHelper: t('SALES_PROPERTY.DOCUMENTS.TYPES_HELPER'),
  validityDays: t('SALES_PROPERTY.DOCUMENTS.VALIDITY_DAYS'),
});

export const salesPartyDocumentText = (t, i18nScope) =>
  i18nScope === 'SALES_PROPERTY' ? propertyText(t) : partyText(t);
